import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEcdConnectEmoji4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 173,
	height: 174,
	viewBox: "0 0 173 174",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M86.35 163.598C128.52 163.598 162.7 129.418 162.7 87.2482C162.7 45.0782 128.52 10.8882 86.35 10.8882C44.18 10.8882 10 45.0682 10 87.2382C10 129.408 44.18 163.588 86.35 163.588",
			fill: "#FF2180"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4 82.1482C55.4 90.5482 48.59 97.3482 40.2 97.3482C31.81 97.3482 25 90.5382 25 82.1482C25 73.7582 31.81 66.9482 40.2 66.9482C48.59 66.9482 55.4 73.7582 55.4 82.1482Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.74 76.2581C39.74 78.7281 37.7401 80.7281 35.2701 80.7281C32.8001 80.7281 30.8 78.7281 30.8 76.2581C30.8 73.7881 32.8001 71.7881 35.2701 71.7881C37.7401 71.7881 39.74 73.7881 39.74 76.2581Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.65 83.3083C44.65 84.7283 43.5 85.8783 42.08 85.8783C40.66 85.8783 39.51 84.7283 39.51 83.3083C39.51 81.8883 40.66 80.7383 42.08 80.7383C43.5 80.7383 44.65 81.8883 44.65 83.3083Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.72 82.1482C147.72 90.5482 140.91 97.3482 132.52 97.3482C124.13 97.3482 117.32 90.5382 117.32 82.1482C117.32 73.7582 124.13 66.9482 132.52 66.9482C140.91 66.9482 147.72 73.7582 147.72 82.1482Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.07 76.2581C132.07 78.7281 130.07 80.7281 127.6 80.7281C125.13 80.7281 123.13 78.7281 123.13 76.2581C123.13 73.7881 125.13 71.7881 127.6 71.7881C130.07 71.7881 132.07 73.7881 132.07 76.2581Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.97 83.3083C136.97 84.7283 135.82 85.8783 134.4 85.8783C132.98 85.8783 131.83 84.7283 131.83 83.3083C131.83 81.8883 132.98 80.7383 134.4 80.7383C135.82 80.7383 136.97 81.8883 136.97 83.3083Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.11 110.308C51.11 114.578 46.45 118.048 40.7 118.048C34.95 118.048 30.29 114.588 30.29 110.308C30.29 106.028 34.95 102.568 40.7 102.568C46.45 102.568 51.11 106.028 51.11 110.308Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.42 110.308C142.42 114.578 137.76 118.048 132.01 118.048C126.26 118.048 121.6 114.588 121.6 110.308C121.6 106.028 126.26 102.568 132.01 102.568C137.76 102.568 142.42 106.028 142.42 110.308Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4 67.4583C35.47 63.7783 44.53 60.0983 53.6 56.4083C54.8 55.9183 55.63 54.8483 55.26 53.4883C54.95 52.3483 53.54 51.3483 52.34 51.8283C43.27 55.5083 34.21 59.1983 25.14 62.8783C23.94 63.3683 23.11 64.4383 23.48 65.7983C23.79 66.9383 25.2 67.9383 26.4 67.4583Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.57 62.8882C138.5 59.2082 129.44 55.5282 120.38 51.8382C119.18 51.3482 117.78 52.3582 117.46 53.4982C117.09 54.8582 117.92 55.9282 119.12 56.4182L146.31 67.4682C147.51 67.9582 148.91 66.9482 149.23 65.8082C149.6 64.4482 148.77 63.3782 147.57 62.8882Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.75 110.628C92.69 114.278 90.29 117.948 86.36 118.028C82.44 118.108 80.03 114.148 79.97 110.628C79.91 106.978 82.52 103.308 86.36 103.228C90.28 103.148 92.69 107.108 92.75 110.628C92.8 113.678 97.54 113.688 97.49 110.628C97.39 104.358 92.91 98.6182 86.36 98.4882C79.81 98.3482 75.33 104.578 75.23 110.628C75.13 116.898 79.97 122.638 86.36 122.768C92.91 122.908 97.39 116.688 97.49 110.628C97.54 107.568 92.8 107.578 92.75 110.628Z",
			fill: "#1C1C1C"
		})
	]
});
export default SvgEcdConnectEmoji4;
